import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { DataBootStrap } from 'src/app/dao/data-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {

   constructor(
    private translate: TranslateService,
    private dataBootstrap: DataBootStrap
  ) {
      translate.addLangs(['en', 'fr']);
      translate.setDefaultLang('en');
      const browserLang = translate.getBrowserLang();
     translate.use(browserLang?.match(/en|fr/) ? browserLang : 'en');
  }

}
